import type { LinkIncentive } from '@/services/link-incentive';

/**
 * Production's published carousel (Builder `carousel-snackbar`, entry "CM",
 * three-item variation), in its order. Each prize names its own catalog keys
 * in full, so every key it shows is a plain reference the locale checks see.
 */
export const REWARDS_CAROUSEL_ITEMS = [
  {
    key: 'theragun-mini',
    nameKey: 'rewardsCarousel.items.theragun.name',
    pointsKey: 'rewardsCarousel.items.theragun.points',
    image: '/signup/rewards/theragun-mini.png',
  },
  {
    key: 'heated-neck-wrap',
    nameKey: 'rewardsCarousel.items.neckWrap.name',
    pointsKey: 'rewardsCarousel.items.neckWrap.points',
    image: '/signup/rewards/heated-neck-wrap.png',
  },
  {
    key: 'yeti-mug',
    nameKey: 'rewardsCarousel.items.yeti.name',
    pointsKey: 'rewardsCarousel.items.yeti.points',
    image: '/signup/rewards/yeti-mug.png',
  },
] as const;

/**
 * The Oura campaign's one card, with the landing page's copy. No Oura price
 * has been agreed, so a line about the welcome call's points takes the place
 * of the "Redeemable at" pill.
 */
const OURA_RING_ITEM = {
  key: 'oura-ring',
  nameKey: 'rewardsCarousel.items.oura.name',
  lineKey: 'rewardsCarousel.items.oura.line',
  image: '/signup/rewards/oura-ring.png',
} as const;

/** The $75 gift card campaign's one card: 7,500 points, the welcome call's worth. */
const GIFT_CARD_ITEM = {
  key: 'gift-card-75',
  nameKey: 'rewardsCarousel.items.giftCard.name',
  pointsKey: 'rewardsCarousel.items.giftCard.points',
  image: '/signup/rewards/gift-card-75.png',
} as const;

/** A prize the rewards carousel shows. */
export type RewardsCarouselItem =
  | (typeof REWARDS_CAROUSEL_ITEMS)[number]
  | typeof OURA_RING_ITEM
  | typeof GIFT_CARD_ITEM;

/**
 * The prizes for the link's incentive code: the campaign's one card for the
 * Oura and gift card codes, production's three otherwise.
 */
export function rewardsCarouselItems(
  incentive: LinkIncentive | undefined,
): readonly RewardsCarouselItem[] {
  if (incentive === 'gifts-oura') return [OURA_RING_ITEM];
  if (incentive === 'monetary') return [GIFT_CARD_ITEM];
  return REWARDS_CAROUSEL_ITEMS;
}

/** The shared backdrop behind each prize. */
export const REWARDS_CAROUSEL_BACKGROUND = '/signup/rewards/background.png';

/** How long each prize shows before the next. */
export const REWARDS_CAROUSEL_INTERVAL_MS = 3000;
